import {Localization} from '../../models/localization.model';
import {ValidationError} from '../../models/validation-error.model';
import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace LocalizationActions {
    export class GetById {
        static readonly type = 'LocalizationActions.GetById';

        constructor(public partnerId: number, public localizationId: number) {}
    }

    export class GetListPage {
        static readonly type = '[Localization] GetListPage';

        constructor(public params?: SearchQueryParams) {}
    }

    export class Activate {
        static readonly type = '[Localization] Activate';

        constructor(public partnerId: number, public localizationId: number) {}
    }

    export class Deactivate {
        static readonly type = '[Localization] Deactivate';

        constructor(public partnerId: number, public localizationId: number) {}
    }

    export class Add {
        static readonly type = '[Localization] Add';

        constructor(public partnerId: number, public readonly localization: Localization) {}
    }

    export class Update {
        static readonly type = '[Localization] Update';

        constructor(public readonly localization: Localization) {}
    }

    export class FormFailure {
        static readonly type = '[Localization] FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {}
    }

    export class FilterList {
        static readonly type = 'LocalizationActions.FilterList';

        constructor(public partnerId: number) {}
    }

    export class Clear {
        static readonly type = 'LocalizationActions.Clear';
    }

    export class ListClear {
        static readonly type = 'LocalizationActions.ListClear';
    }
}
